module.exports = __webpack_public_path__ + "img/00047.f6ea2320.webp";